export default class NotificationReadRes { [key: string]: any; }
